import { Component, Inject, OnInit, Optional } from '@angular/core';
import { animate, style, transition, trigger } from "@angular/animations";
import { ActivatedRoute, Router } from "@angular/router";
import { Compbaser } from "../../../components/compbaser";
import { AuthUserService } from "../../../services";
import { EnumStudioType, loginUrlType } from "../../../interfaces";
import { LocalStoreService } from "../../../services";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { DialogAssetViewerComponent, IDialogAssetViewer } from "../dialog-asset-viewer/dialog-asset-viewer.component";
import { appData } from "../../../common";

@Component({
    selector: 'app-started-pick',
    templateUrl: './started-pick.component.html',
    styleUrls: ['./started-pick.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition('* => *', [
                style({ opacity: 0 }),
                animate('300ms ease-in-out')
            ])
        ])
    ]
})
export class StartedPickComponent extends Compbaser implements OnInit {

    EnumStudioType = EnumStudioType;
    popupMode;
    model;
    mode: loginUrlType;

    constructor(private authUserService: AuthUserService,
        protected override dialog: MatDialog, @Optional() @Inject(MAT_DIALOG_DATA) data: any,
        private route: ActivatedRoute, public router: Router,
        private localStore: LocalStoreService) {
        super();
        // @Optional() @Inject(MAT_DIALOG_DATA) data
        // if (data) {
        //     this.popupMode = true;
        //     this.model = data;
        // }
        this.route.paramMap.subscribe((routeParams) => {
            this.mode = routeParams.get('mode') as loginUrlType;
        });
    }

    ngOnInit() {
    }

    goBack() {
        this.authUserService.backToLogin();
    }

    // showVideo(studioType: EnumStudioType, event) {
    //   event.stopImmediatePropagation();
    //   event.stopPropagation();
    //   event.preventDefault();
    //   this.openDialog('1', {});
    // }

    openDialogPreview(event, row, studioType: EnumStudioType): void {
        event.stopImmediatePropagation();
        event.preventDefault();
        let videos = [];
        const images = [];
        if (studioType == EnumStudioType.PRO) {
            videos = ['https://oregon-signage-resources.s3.amazonaws.com/business1000/resources/quickypro.mp4'];
        } else {
            videos = ['https://oregon-signage-resources.s3.amazonaws.com/business1000/resources/quickyv2.mp4'];
        }
        const data: IDialogAssetViewer = {
            videos,
            images,
            autoMoveNext: false,
            autoMoveNextTime: 1,
        };
        const dialogRef = this.dialog.open(DialogAssetViewerComponent, {
            height: '550px',
            width: '800px',
            data
        });
        this.cod(
            dialogRef.afterClosed().subscribe(result => {
                // console.log('The dialog was closed ' + result);
            })
        );
    }

    override openDialog(message: string, options: {}): void {
        const dialogRef = this.dialog.open(DialogAssetViewerComponent, {
            height: '768px',
            width: '1024px',
            data: { name: appData.cloudResourcesS3 + '/business1000/resources/samples/1019.mp4' }
        });
        this.cod(
            dialogRef.afterClosed().subscribe(result => {
                // console.log('The dialog was closed ' + result);
            })
        );
    }

    navigateTo(v: EnumStudioType) {
        // if (this.popupMode) {
        //     this.model.callBack(v);
        this.localStore.setStorageValConfig('socialUserPendingStudioType', v);
        if (this.mode) {
            this.router.navigateByUrl(`/getstarted/template/${this.mode}`);
        } else {
            this.router.navigateByUrl(`/getstarted/template`);
        }
    }
}

